import React, { useState } from "react";

import { useLocation } from "react-router-dom";

import TagMeetingHeader from "../components/TagMeetingHeader";
import TagRegularizeMeetingForm from "../components/TagRegularizeMeetingForm";
import ThankYouComponent from "../components/ThankYouComponent";
import constant from "../utils/constants";

const RegularizeMeeting = () => {
  const location = useLocation();
  const date = location.state;
  const [showSuccess, setShowSuccess] = useState(false);

  return (
    <>
      <TagMeetingHeader headerName={"Regularize meeting"} />
      {showSuccess ? (
        <ThankYouComponent message="Done! Your meeting is set for the day." />
      ) : (
        <TagRegularizeMeetingForm
          meetingName={constant.regularize_type}
          setShowSuccess={setShowSuccess}
          date={date}
        />
      )}
    </>
  );
};

export default RegularizeMeeting;
